import html2Canvas from 'html2canvas'
import * as JsPDF from 'jspdf'

export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function (domId, _title) {
      var dom = `#${domId}`
      var title = _title
      var c = document.createElement('canvas')
      var opts = {
        scale: 2,
        canvas: c,
        logging: true,
        width: document.querySelector(dom).clientWidth,
        height: document.querySelector(dom).clientHeight,
      }
      c.width = document.querySelector(dom).clientWidth * 2
      c.height = document.querySelector(dom).clientHeight * 2
      c.getContext('2d').scale(2, 2)
      html2Canvas(document.querySelector(dom), opts).then(function (canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let paperHeight = contentWidth / 419.53 * 595.28
        let pageHeight = contentHeight
        let imgWidth = 419.53
        let imgHeight = 419.53 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let pdf = new JsPDF('l', 'px', 'a5')
        console.log('imgHeight: ', imgHeight, 'contentHeight: ', contentHeight, contentHeight * 0.26)
        console.log('imgWidth: ', imgWidth, 'contentWidth: ', contentWidth, contentWidth * 0.26)
        // let paddingLeft = ((595.28 - contentWidth * 0.26) / 2)
        let paddingTop = ((419.53 - contentHeight * 0.26) / 5)
        if (pageHeight <= paperHeight) {
          pdf.addImage(pageData, 'JPEG', 10, paddingTop, imgWidth, imgHeight)
        }
        // let position = 0
        // else {
        //   while (leftHeight > 0) {
        //     pdf.addImage(pageData, 'JPEG', paddingLeft, position, imgWidth, imgHeight)
        //     leftHeight -= pageHeight
        //     position -= 595.28
        //     if (leftHeight > 0) {
        //       pdf.addPage()
        //     }
        //   }
        // }
        pdf.save(title + '.pdf')
      })
    }
  },
}
